import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../api/services/auth.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewTeamComponent } from '../new-team/new-team.component';
import { UserService } from '../../../api/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from '../../../api/services/preferences.service';
import { Team } from '../../../api/models/team';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';

@Component({
  selector: 'app-team-list',
  templateUrl: './team-list.component.html',
  styleUrls: ['./team-list.component.scss']
})
export class TeamListComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private userService: UserService,
    private preferencesService: PreferencesService
  ) { }

  teams = [];
  teamsAll = [];
  pageSize = 50;
  teamsToShow = [];
  page = 1;
  edit = false;
  teamSelected: Team;
  infoMsg = ['No records found!'];

  orgId: string;
  userId: string;
  visibleContext: boolean = false;
  loading = true;
  contractorTeamType: number = 2;

  editTeam(team: Team) {
    this.teamSelected = team;
    this.edit = true;
  }

  delete(team: Team) {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the Team <strong>${ team.name }</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.authService.deleteTeam(team.id).subscribe(() => {
        modalRef.close();
        this.refresh();
      }, error => {
        modalRef.close();
        this.onDeleteError();
      });
    };
  }

  backToListing() {
    this.edit = false;
    this.refresh();
  }

  refresh() {
    this.loading = true;
    this.authService.getTeamsForOrganization(this.orgId, this.userId)
      //.map(teams => (teams.sort((a, b) => a.id > b.id ? 1 : -1)))
      .subscribe(items => {
        this.teams = items;
        this.teamsAll = items.slice();
        this.loadPage(this.page);
      });
  }

  loadPage(page) {
    const from = (page - 1) * this.pageSize;
    const to = from + this.pageSize;
    this.teamsToShow = this.teamsAll.slice(from, to);
    this.loading = false;
  }

  search(value) {
    if (value) {
      this.teams = this.teamsAll.filter(x => x.name.toLowerCase().includes(value.toLowerCase()));
      this.teamsToShow = this.teams.slice(0, this.pageSize);
    } else {
      this.teams = this.teamsAll.slice();
      this.teamsToShow = this.teamsAll.slice(0, this.pageSize);
    }
    this.page = 1;
  }

  private onUpdateSuccess() {
    this.toastr.success('Team created ! ! !', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onDeleteError() {
    this.toastr.error('Error deleting team! ! !', 'Error!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  createTeam() {
    const modalRef = this.modalService.open(NewTeamComponent, {
      backdrop: 'static',
      keyboard: false
    });

    modalRef.result
      .then(() => {
        this.onUpdateSuccess();
        this.refresh();
      })
      .catch(() => { 
        //Empty catch block
      });
  }

  ngOnInit() {
    this.calculatePermissions(['TEAM_UPDATE']);

    this.userService.findUserById(this.authService.getUserId())
      .switchMap(user => {
        this.orgId = user['Organization ID'];
        this.userId = user['User ID'];
        return this.authService.getTeamsForOrganization(this.orgId, this.userId);
      }).subscribe(teams => {
        this.teams = teams;
        this.authService.getUserTeamByType(this.authService.getUserId(), this.contractorTeamType).subscribe(team => {
          if (team.type != undefined && team.type != null && team.type === this.contractorTeamType) {
              this.teams = this.teams.filter(contractorTeam => contractorTeam.name === team.name);
              return true;
          }
          this.teamsAll = this.teams.slice();
          this.loadPage(this.page);
        });
      });
  }

  calculatePermissions(requiredRoles: string[], context?: string) {
    if (context === 'MARKET') {
      this.preferencesService.getPreferences('USER', this.authService.getUserId())
        .subscribe(prefs => {
          const currentMarket = prefs['current-market'].Value;
          this.authService.getUserRolesInContext(`${context}~${currentMarket}`).subscribe(roles => {
            this.visibleContext = requiredRoles.every(r => roles.includes(r));
          });
        });
    } else {
      this.userService.findUserById(this.authService.getUserId()).subscribe(user => {
        const con = `ORGANIZATION~${user['Organization ID']}`;
        this.authService.getUserRolesInContext(con).subscribe(roles => {
          this.visibleContext = requiredRoles.every(r => roles.includes(r));
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/team-list/team-list.component.ts